import React from 'react'
import Modal from 'react-modal'
import { Button, Glyphicon } from 'react-bootstrap'

import useForm from '../../../hooks/useForm'

type MapViewer = { _id: String, name: String, email: String }

type Props = {
  isModalOpen: Boolean,
  closeModal: Function,
  removeMapViewer: Function,
  updateMapViewer: Function,
  mapViewer: MapViewer,
}
const translations = {
  name: 'Namn & Efternamn',
  email: 'Email',
  zip: 'Postnummer (t.ex. värdet "1;43;2" gör att användaren kan se projekt och leveranser till postnummer som börjar med 1 respektive 43 och 2)',
  password: 'Lösenord',
}

const getDefaultFormValues = (mapViewer) =>
  Object.keys(translations).reduce(
    (acc, key) => ({
      ...acc,
      [key]: mapViewer[key],
    }),
    {}
  )

const HandleMapViewerModal = ({ isModalOpen, closeModal, mapViewer, updateMapViewer, removeMapViewer }: Props) => {
  const defaultFormValues = getDefaultFormValues(mapViewer)

  const [formValues, onFormChange, resetForm] = useForm(defaultFormValues)

  return (
    <Modal isOpen={isModalOpen} onRequestClose={closeModal}>
      <button onClick={closeModal}>Stäng</button>
      <hr />

      {Object.entries(formValues).map(([key, value]) => (
        <div key={key} className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
          <label style={{ paddingRight: 21 }}>{`${translations[key]}:`}</label>
          <input onChange={onFormChange} name={key} className="change-input form-control" type="text" value={value} />
        </div>
      ))}

      <Button
        className="save-settings-btn"
        style={{ width: '100%' }}
        type="submit"
        onClick={() =>
          updateMapViewer({ _id: mapViewer._id, ...formValues }).then(() => {
            resetForm()
            closeModal()
          })
        }
      >
        <Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Spara
      </Button>

      <Button className="smallQbuttonWarning" style={{ width: '100%' }} type="submit" onClick={() => removeMapViewer(mapViewer._id, mapViewer.email, closeModal)}>
        <Glyphicon glyph="glyphicon glyphicon-remove" /> &nbsp; Ta bort tillgång
      </Button>

      <hr style={{ width: '100%', marginTop: 80 }} />
    </Modal>
  )
}

export default HandleMapViewerModal
